import { Component, input } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss'],
  imports: [TooltipModule]
})
export class HintComponent {
  public customIcon = input('ri-information-2-fill');
  public customColor = input('#D09A3C');
}
